import { render, staticRenderFns } from "./EnglishSubmitList.vue?vue&type=template&id=12342397&scoped=true"
import script from "./EnglishSubmitList.vue?vue&type=script&lang=js"
export * from "./EnglishSubmitList.vue?vue&type=script&lang=js"
import style0 from "./EnglishSubmitList.vue?vue&type=style&index=0&id=12342397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12342397",
  null
  
)

export default component.exports